var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullscreenSelected = function SvgFullscreenSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fullscreen-selected_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 43 44",
    style: {
      enableBackground: "new 0 0 43 44"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fullscreen-selected_svg__st1{fill:none;stroke:#fff;stroke-width:2}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc4405",
      stroke: "#dc4405",
      strokeWidth: 2
    },
    d: "M1 1.2h41v41H1z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fullscreen-selected_svg__st1",
    d: "m32.8 10-23 23m23-23v5m0-5h-4.9M9.8 33h5m-5 0v-5M32.8 33l-23-23m23 23h-5m5 0v-4.9M9.7 10v5m0-5h5-5z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 21.172 21.64)",
    style: {
      fill: "#dc4405"
    },
    d: "M12.4 12.9h17.5v17.5H12.4z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fullscreen-selected_svg__st1",
    d: "M9.7 15v-5h5.1M27.8 10h5v5M32.8 28v5h-5M14.7 33h-5v-5"
  })));
};
export default SvgFullscreenSelected;